// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SectorAirDeleteDialogComponent } from './sector-air-delete-dialog.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';

import { SectorModule } from 'libraries/sector/sector.module';
import {NotificationModule} from "../../../../../../notification/notification.module";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        CardModule,
        LoaderModule,
        SectorModule,
        NotificationModule
    ],
    exports: [
        SectorAirDeleteDialogComponent,
    ],
    declarations: [
        SectorAirDeleteDialogComponent,
    ],
})
export class SectorAirDeleteDialogModule {}
